export default function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else if (!this.hasClass(el, className)) {
    el.className += " " + className;
  }
}
